import { required } from 'vuelidate/lib/validators';

const modalValidations = {
  title: {
    required,
  },
  description: {
    required,
  },
  businessType: {
    required,
  }
};

export default modalValidations;